import { types } from "@proj/static";
import http from "../utils/http";

export const getAdminUsers = async () => {
    let result = await (await http().get(`/adminusers`)).data;
    return result.data;
}